import React, { Component } from 'react';
import FaceDissatisfied from '@carbon/icons-react/lib/face--dissatisfied/32';
export default class Unauthorized extends Component {
    displayName = "Unauthorized"

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="unauthorized">
                <div>
                    <img className="logo-full" src="/images/saipem-full.png" />
                    <div className="">
                        <h5>InSight</h5>
                        <h2>Access denied</h2>
                        <p>You are not authorized to view this content. Please contact the system administrator.
                        </p>
                    </div>
                </div>
            </div>

        );
    }
}
